<template>
  <div>
    <v-toolbar flat class="cactus-primary--toolbar">
        <v-btn color="primary" @click="showCreateDialog = true">Create</v-btn>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-layout class="pa-4">
      <v-flex>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td style="width: 80px;">{{props.item.user_id}}</td>
          <td class="text-xs-left">{{props.item.first_name}}</td>
          <td class="text-xs-left">{{props.item.last_name}}</td>
          <td class="text-xs-left">{{props.item.username}}</td>
          <td class="text-xs-left">{{props.item.role}}</td>
          <td class="text-xs-left">{{props.item.last_login_date}}</td>
          <td class="text-xs-center  px-0" style="width: 80px">
            <v-tooltip bottom v-if="props.item.user_id >= 0">
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" @click="deleteUser(props.item)">
                  <template>delete</template>
                </v-icon>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </td>
        </template>
      </v-data-table>
      <InfiniteLoading @infinite="scrollLoad" :identifier="infiniteLoaderId"></InfiniteLoading>
      </v-flex>
    </v-layout>
    <UserCreateDialog v-model="showCreateDialog" @save="reload"></UserCreateDialog>
  </div>
</template>

<script>
import UserDetailsAPI from '@/api/userdetails.js'
import InfiniteLoading from 'vue-infinite-loading'
import UserCreateDialog from './dialog--create-user'
import UserAPI from '@/api/user.js'
import {mapState} from 'vuex'

export default {
  components: {
    InfiniteLoading,
    UserCreateDialog
  },
  data () {
    return {
      showCreateDialog: false,
      pagination: {
        perPage: 100,
        page: 0
      },
      items: [],
      headers: [
        {
          text: 'Id',
          value: 'user_id'
        },
        {
          text: 'First name',
          value: 'first_name'
        },
        {
          text: 'Last name',
          value: 'last_name'
        },
        {
          text: 'Username',
          value: 'username'
        },
        {
          text: 'Role',
          value: 'role'
        },
        {
          text: 'Last Login',
          value: 'last_login_date'
        },
        {
          text: 'Actions',
          sortable: false,
          value: 'user_id'
        }
      ],
      loading: false,
      infiniteLoaderId: +new Date()
    }
  },
  computed: {
    ...mapState(['user']),
    filterParams () {
      return {
        user_id: {filter: 'isnot', value: 'null'}
      }
    }
  },
  methods: {
    reload () {
      this.infiniteLoaderId += 1 // resets the infinite loader when filters change
      this.pagination.page = 0
      this.items = []
    },
    async scrollLoad ($state) {
      // $state from infinite-loader component
      const data = await this.getUsers()
      if (data.length) {
        this.items = [...this.items, ...data]
        this.pagination.page += 1
        $state.loaded()
        data.length < this.pagination.perPage && $state.complete()
      } else {
        $state.complete()
      }
    },
    async getUsers () {
      this.loading = true
      const {data} = await UserDetailsAPI.getFull({filterParams: this.filterParams})
      this.loading = false
      return data
    },
    async deleteUser (user) {
      if (confirm('Are you sure you wish to delete this user? Deleting a user will keep their user details but they will not be able to log in.')) {
        const idx = this.items.indexOf(user)
        if (idx > -1) {
          UserAPI.delete(user.user_id)
          this.items.splice(idx, 1)
        }
      }
    }
  }
}
</script>

<style>

</style>
